import {
  faArrowLeft,
  faMinusCircle,
  faPlusCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Autocomplete,
  Box,
  Button,
  FormControl,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import dayjs from "dayjs";
import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Page from "../../component/Page";
import { getBranchList, LocationList } from "../setting/services/settingApi";
import { PLAN_CONFIG } from "./config";
import PlanContext from "./services/planApi";
import api from "../../api/api";
import ConfirmPlanPrint from "./component/confirmPlanPrint";
import ConfirmDialogPs from "./component/confirmDialogPs";
import "./viewPromoteSpread.scss";
import Swal from "sweetalert2";
import {
  AMOUNT_FIELDS,
  formatAmountInput,
  formatTotal,
  sumAmounts,
  toAmountPayload,
} from "./promoteSpreadAmounts";

// เดือนตามปีงบประมาณ ต.ค. - ก.ย.
const FISCAL_MONTHS = [
  { Month: 10, name: "ตุลาคม" },
  { Month: 11, name: "พฤศจิกายน" },
  { Month: 12, name: "ธันวาคม" },
  { Month: 1, name: "มกราคม" },
  { Month: 2, name: "กุมภาพันธ์" },
  { Month: 3, name: "มีนาคม" },
  { Month: 4, name: "เมษายน" },
  { Month: 5, name: "พฤษภาคม" },
  { Month: 6, name: "มิถุนายน" },
  { Month: 7, name: "กรกฎาคม" },
  { Month: 8, name: "สิงหาคม" },
  { Month: 9, name: "กันยายน" },
];

const createEmptyMonths = () =>
  FISCAL_MONTHS.map(({ Month, name }) => ({
    name,
    Month,
    ...Object.fromEntries(AMOUNT_FIELDS.map((field) => [field, null])),
    Total: null,
    Province: [
      { provinceName: "", rowIndex: 1, DPDetailId: null, DPHeadId: null },
    ],
  }));

// ช่องกรอกจำนวน (ตัน) พิมพ์ได้เฉพาะตัวเลข และใส่คอมมาคั่นหลักพันให้ระหว่างพิมพ์
function AmountCell({ value, onChange }) {
  return (
    <td>
      <TextField
        value={value ?? ""}
        size="small"
        fullWidth
        variant="outlined"
        onChange={(e) => onChange(formatAmountInput(e.target.value))}
        onKeyPress={(event) => {
          if (!/\d/.test(event.key)) {
            event.preventDefault();
          }
        }}
      />
    </td>
  );
}

export default function ViewPromoteSpread() {
  const { profile, loading } = useSelector((state) => state.profile);
  const { id } = useParams();
  const navigate = useNavigate();
  const { getPlanDistributionDetail } = useContext(PlanContext);
  const [detail, setDetail] = useState();
  const [listLocation, setListLocation] = useState([]);
  const [key, setKey] = useState("");
  const [year, setYear] = useState("");
  const [BranchNo, setBranchsNo] = useState("");
  const [branchs, setBranchs] = useState([]);
  const [remark, setRemark] = useState();
  const [open, setOpen] = useState(false);
  const [openP, setOpenP] = useState(false);
  const [yearError, setyearError] = useState(false);
  const [version, setVersion] = useState('1');

  useEffect(() => {
    if (id) {
      getPlanDistributionDetail(id, setDetail);
    }
    getBranchList(null, setBranchs);
    setBranchsNo(profile?.BranchNo?.BranchNo);
  }, []);

  useEffect(() => {
    LocationList(
      {
        typeSearch: "P",
        Text: key,
      },
      setListLocation
    );
  }, [key]);

  useEffect(() => {
    if (id) {
      setBranchsNo(detail?.BranchNo?.BranchNo);
      setYear(detail?.Year);
      setRemark(detail?.Remark);
    }
  }, [detail]);

  const [months, setMonths] = useState(createEmptyMonths);
  useEffect(() => {
    if (detail?.PlanDetails?.length > 0) {
      const _plan = detail?.PlanDetails.filter(
        (v, i, a) => a.findIndex((t) => t.Month === v.Month) === i
      );
      // const months = this.planDistribution.PlanDetails.map(x => x.)
      for (const c of _plan) {
        const _months = [];
        const monthDlu = detail?.PlanDetails?.filter(
          (x) => x.Month === c.Month
        );
        const find = months.find((x) => x.Month === c.Month);
        // แถวเก่าที่บันทึกก่อนมีช่อง ลด 7% อาจเป็น null จึงตั้งต้นเป็น 0
        for (const field of AMOUNT_FIELDS) {
          find[field] = formatAmountInput(String(c[field] ?? 0));
        }
        find.Total = c.Total;
        for (const p of monthDlu) {
          let i = 0;
          _months.push({
            provinceName: p.ProvinceName,
            rowIndex: i++,
            DPDetailId: p.DPDetailId,
            DPHeadId: p.DPHeadId,
          });
        }
        find.Province = _months;
      }
    }
  }, [detail]);

  const updateAmount = (month, field, value) => {
    setMonths((prev) =>
      prev.map((v) => (v.Month === month ? { ...v, [field]: value } : v))
    );
  };

  const handleSubmit = async () => {
    const planDetail = [];
    if (months.length > 0) {
      for (const x of months) {
        if (x.Province.length > 0) {
          for (const p of x.Province)
            if (p.provinceName) {
              planDetail.push({
                DPDetailId: p.DPDetailId || undefined,
                DPHeadId: p.DPHeadId || undefined,
                Month: x.Month,
                ...toAmountPayload(x),
                Total: sumAmounts(x),
                ProvinceName: p.provinceName,
              });
            }
        }
      }
    }
    const body = {
      BranchNo: BranchNo,
      DocumentNo: id || "",
      DocumentDate: dayjs(new Date()).format("YYYY-MM-DD"),
      Year: year,
      Remark: remark,
      PlanDetails: planDetail,
      Version: version,

    };
    const planDistributionAdd = async () => {
      if (id) {
        const url =
          PLAN_CONFIG.requests.getPlanDistribution.url + `/${body?.DocumentNo}`;
        const res = await api.put(url, body);
        const data = res.data;
        if (data.status === true) {
          setOpen(false);
          setOpenP(true);
        }
      } else {
        const res = await api.post(
          PLAN_CONFIG.requests.getPlanDistribution.url,
          body
        );
        const data = res.data;
        if (data.status === true) {
          navigate("/plan/promote-spread/" + data.result.DocumentNo);
          setOpen(false);
          setOpenP(true);
        } else {
          Swal.fire({
            title: data?.message || "ทำรายการไม่สำเร็จ",
            icon: "warning",
          });
        }
      }
    };
    planDistributionAdd();
  };
  return (
    <div style={{ padding: "10px 30px" }}>
      <Page>
        <form>
          <div class="container-fluid">
            <div class="d-flex row align-items-center ">
              <div class="col-12">
                <label class="title-content mb-4">
                  ข้อมูลแผนการส่งเสริมการกระจายเมล็ดพันธุ์ข้าว
                </label>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-4 col-md-12">
                <label class="labelInput">ศูนย์เมล็ดพันธุ์ข้าว</label>
                <Box className="backgroundField" sx={{ marginBottom: "10px" }}>
                  <FormControl variant="standard" fullWidth>
                    <Select
                      value={BranchNo || ""}
                      onChange={(e) => setBranchsNo(e.target.value)}
                      disableUnderline
                    >
                      {branchs?.map((x) => (
                        <MenuItem value={x?.BranchNo}>{x?.BranchName}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              </div>
              <div class="col-lg-4 col-md-6">
                <label class="labelInput">ปีงบประมาณ</label>
                <Box className={`backgroundField ${yearError ? "error" : ""}`}>
                  <TextField
                    value={year}
                    onChange={(e) => setYear(e.target.value)}
                    variant="standard"
                    fullWidth
                    onBlur={(e) => {
                      if (!e.target.value) {
                        setyearError(true);
                      } else {
                        setyearError(false);
                      }
                    }}
                    InputProps={{
                      disableUnderline: true,
                    }}
                  />
                </Box>
                {yearError && (
                  <span style={{ color: "red", fontSize: "12px" }}>
                    กรุณาเลือกปีงบประมาณ
                  </span>
                )}
              </div>
              <div class="col-lg-4 col-md-6 row align-items-center">
                <RadioGroup
                  value={version || ""}
                  onChange={(e) => setVersion(e.target.value)}
                  row
                >
                  <FormControlLabel
                    value="1"
                    disabled={id}
                    control={<Radio />}
                    label="ครั้งที่ 1 (ต.ค. - ก.ย.)"
                  />
                  <FormControlLabel
                    value="2"
                    disabled={id}
                    control={<Radio />}
                    label="ครั้งที่ 2 (เม.ย. - ก.ย.)"
                  />
                </RadioGroup>
              </div>
            </div>
            {id && (
              <div class="row">
                <div class="col-lg-4 col-md-6">
                  <label class="labelInput me-3">ผู้สร้าง</label>{" "}
                  <label class="message-error-label">
                    ( {dayjs(detail?.CreateDate).format("DD/MM/BBBB")} )
                  </label>
                  <Box
                    className="backgroundField"
                    sx={{ marginBottom: "10px" }}
                  >
                    <TextField
                      disabled
                      value={detail?.CreateId}
                      variant="standard"
                      fullWidth
                      InputProps={{
                        disableUnderline: true,
                      }}
                    />
                  </Box>
                </div>
                <div class="col-lg-4 col-md-6">
                  <label class="labelInput me-3">ผู้แก้ไข</label>{" "}
                  <label class="message-error-label">
                    ( {dayjs(detail?.ModifiedDate).format("DD/MM/BBBB")} )
                  </label>
                  <Box
                    className="backgroundField"
                    sx={{ marginBottom: "10px" }}
                  >
                    <TextField
                      disabled
                      value={detail?.ModifiedId}
                      variant="standard"
                      fullWidth
                      InputProps={{
                        disableUnderline: true,
                      }}
                    />
                  </Box>
                </div>
              </div>
            )}
            <div class="row">
              <div class="col-lg-8 col-md-12">
                <label class="labelInput">หมายเหตุ</label>
                <Box
                  className="backgroundField"
                  sx={{ marginBottom: "10px", borderRadius: "25px" }}
                >
                  <TextField
                    value={remark}
                    onChange={(e) => setRemark(e.target.value)}
                    variant="standard"
                    fullWidth
                    multiline
                    rows={3}
                    InputProps={{
                      disableUnderline: true,
                    }}
                  />
                </Box>
              </div>
            </div>

            <div class="viewPromoteSpread row">
              <div class="text-end " style={{ color: "red" }}>
                ( หน่วย : ตัน )
              </div>
              <div
                class="col-md-12 table-responsive-sm pb-3"
                style={{ height: "auto" }}
              >
                <table class="table table-bordered table-hover ">
                  <thead>
                    <tr>
                      <th
                        scope="col "
                        rowspan="3"
                        class="text-center"
                        style={{ width: "10%" }}
                      >
                        ช่วงเวลา(เดือน)
                      </th>
                      <th scope="col" colSpan={7} className="text-center">
                        สัดส่วนช่องทางการจำหน่าย
                      </th>
                      <th scope="col " rowspan="3" class="text-center">
                        รวม
                      </th>
                      <th scope="col " rowspan="3" class="text-center">
                        สถานที่ที่จะส่งเสริม (ระบุจังหวัด)
                      </th>
                    </tr>
                    <tr>
                      <th scope="col " rowspan="2" class="text-center">
                        โครงการ/ส่วนราชการ
                      </th>
                      <th scope="col" colSpan={4} className="text-center">
                        ตัวแทนจำหน่าย
                      </th>
                      <th scope="col " colspan="2" class="text-center">
                        เกษตรกร/กลุ่มเกษตรกร/ร้านค้า
                      </th>
                    </tr>
                    <tr>
                      <th scope="col " class="text-center">
                        ราคาเต็ม
                      </th>
                      <th scope="col " class="text-center">
                        ลด 5%
                      </th>
                      <th scope="col" className="text-center">
                        ลด 7%
                      </th>
                      <th scope="col " class="text-center">
                        ลด 8%
                      </th>
                      <th scope="col " class="text-center">
                        ราคาเต็ม
                      </th>
                      <th scope="col " class="text-center">
                        ส่วนลด
                      </th>
                    </tr>
                  </thead>
                  <tbody class="">
                    {months?.map((x) => (
                      <tr>
                        <td>{x.name}</td>
                        {AMOUNT_FIELDS.map((field) => (
                          <AmountCell
                            key={field}
                            value={x?.[field]}
                            onChange={(value) =>
                              updateAmount(x.Month, field, value)
                            }
                          />
                        ))}
                        <td class="text-center">
                          {formatTotal(sumAmounts(x))}{" "}
                        </td>
                        <td>
                          {x?.Province?.map((y, index) => (
                            <div
                              class="d-flex align-items-center"
                              style={{ margin: "5px 0" }}
                            >
                              <Autocomplete
                                sx={{ width: "100%", marginRight: "5px" }}
                                value={y?.provinceName}
                                onChange={(event, newValue) => {
                                  const item = months?.map((v) => {
                                    v.Province =
                                      v?.Month === x?.Month
                                        ? v.Province?.map((c, i) => {
                                            c.provinceName =
                                              i === index
                                                ? newValue
                                                : c.provinceName;

                                            return c;
                                          })
                                        : v?.Province;
                                    return v;
                                  });
                                  setMonths(item);
                                }}
                                onInputChange={(event, newInputValue) => {
                                  setKey(newInputValue);
                                }}
                                options={
                                  listLocation.length > 0
                                    ? listLocation
                                        .filter(
                                          (v, i, a) =>
                                            a.findIndex(
                                              (t) =>
                                                t.ProvinceId === v.ProvinceId
                                            ) === i
                                        )
                                        ?.map((option) => option?.ProvinceName)
                                    : []
                                }
                                renderInput={(params) => (
                                  <Box ref={params.InputProps.ref}>
                                    <OutlinedInput
                                      {...params.inputProps}
                                      fullWidth
                                      size="small"
                                      sx={{ padding: "0 !important" }}
                                    />
                                  </Box>
                                )}
                              />
                              {index === 0 ? (
                                <FontAwesomeIcon
                                  icon={faPlusCircle}
                                  style={{ width: "40px" }}
                                  onClick={() => {
                                    x?.Province.push({
                                      provinceName: "",
                                      rowIndex: x?.Province?.slice(-1)[0]
                                        ?.rowIndex
                                        ? x?.Province?.slice(-1)[0]?.rowIndex +
                                          1
                                        : 1,
                                      DPDetailId: null,
                                      DPHeadId: null,
                                    });
                                    const item = months?.map((v) => {
                                      v.Province =
                                        v?.Month === x?.Month
                                          ? x?.Province
                                          : v?.Province;
                                      return v;
                                    });
                                    setMonths(item);
                                  }}
                                />
                              ) : (
                                <FontAwesomeIcon
                                  icon={faMinusCircle}
                                  style={{
                                    width: "40px",
                                    "&.fa-circle-minus": {
                                      fontSize: "1.7rem !important",
                                    },
                                  }}
                                  onClick={() => {
                                    const item = months?.map((v) => {
                                      v.Province =
                                        v?.Month === x?.Month
                                          ? x.Province?.filter(
                                              (e, i) => index !== i
                                            )
                                          : v?.Province;

                                      return v;
                                    });
                                    setMonths([...item]);
                                  }}
                                />
                              )}
                            </div>
                          ))}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <hr class="chr" />
            <div class="row mt-4">
              <div class="col-12 ">
                <Button
                  variant="outlined"
                  onClick={() => navigate(-1)}
                  startIcon={<FontAwesomeIcon icon={faArrowLeft} />}
                  sx={{ width: "130px", fontSize: "14px", marginRight: "10px" }}
                >
                  กลับ
                </Button>
                <Button
                  variant="contained"
                  onClick={() => {
                    if (!year) {
                      setyearError(true);
                    } else {
                      setOpen(true);
                    }
                  }}
                  sx={{ width: "130px", fontSize: "14px" }}
                >
                  {id ? "เเก้ไข" : "บันทึก"}
                </Button>
              </div>
            </div>
          </div>
        </form>
      </Page>
      <ConfirmPlanPrint
        title={"บันทึกรายการแผนการส่งเสริมการกระจายเมล็ดพันธุ์ข้าว"}
        download={null}
        open={openP}
        setOpen={setOpenP}
        loadingPDF={null}
        linkTo="/plan/promote-spread/add"
      />
      <ConfirmDialogPs
        open={open}
        setOpen={setOpen}
        rows={months}
        handleAdd={handleSubmit}
      />
    </div>
  );
}
